import { render, staticRenderFns } from "./XmlOrders.vue?vue&type=template&id=81a90dda&scoped=true"
import script from "./XmlOrders.vue?vue&type=script&lang=ts"
export * from "./XmlOrders.vue?vue&type=script&lang=ts"
import style0 from "./XmlOrders.vue?vue&type=style&index=0&id=81a90dda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a90dda",
  null
  
)

export default component.exports